import clamp from 'lodash/clamp';
import { Action } from 'redux';

import { ANSWER_INPUT_SUBMISSION_ATTEMPTS, CARD_TYPE } from 'common/constants';
import { ClientThunkAction } from 'client/reducers';
import { selectStoryCardSettings } from 'client/reducers/story/selectors';
import { selectUserAnswersByCard } from 'client/reducers/user/selectors';
import { UPDATE_ANSWER_ATTEMPTS } from 'client/constants/actions';

export type UpdateUserAnswerAttemptsParams = {
	cardId: string;
	answerId: string;
};

export type UpdateUserAnswerAttemptsPayload = UpdateUserAnswerAttemptsParams & {
	result: boolean;
};

export function updateAnswerAttempts(
	params: UpdateUserAnswerAttemptsParams
): ClientThunkAction<Action, { isCorrect: boolean; attempts: number; maxAttempts: number }> {
	return async (dispatch, getState) => {
		let state = getState();
		const { cardId, answerId } = params;
		const cardSettings = selectStoryCardSettings(state, cardId);
		const answerSettings = cardSettings?.answers?.[answerId];
		const answerData = selectUserAnswersByCard(state, cardId)?.data?.[answerId];

		const { correctValue: correctValueStr = '' } =
			answerSettings && 'correctValue' in answerSettings ? answerSettings : { correctValue: '' };
		const correctValues = correctValueStr.split(',').map(s => s.trim());
		const isCorrect =
			cardSettings?.type === CARD_TYPE.POLL ||
			correctValues.some(v => v.toLowerCase() === answerData?.textContent?.toLowerCase());

		dispatch({
			type: UPDATE_ANSWER_ATTEMPTS,
			payload: { ...params, result: isCorrect } satisfies UpdateUserAnswerAttemptsPayload,
		});

		state = getState();

		const maxAttempts = clamp(
			parseInt(cardSettings?.maxAttempts ?? '', 10) || ANSWER_INPUT_SUBMISSION_ATTEMPTS.DEFAULT,
			ANSWER_INPUT_SUBMISSION_ATTEMPTS.MIN,
			ANSWER_INPUT_SUBMISSION_ATTEMPTS.MAX
		);
		const answerDataUpd = selectUserAnswersByCard(state, cardId)?.data?.[answerId];
		const answerInputData = answerDataUpd && 'inputData' in answerDataUpd ? answerDataUpd.inputData : undefined;
		const currentAttempts = clamp(
			answerInputData?.attempts ?? 0,
			ANSWER_INPUT_SUBMISSION_ATTEMPTS.MIN,
			maxAttempts
		);

		return {
			isCorrect,
			attempts: currentAttempts,
			maxAttempts,
		};
	};
}
